import { type IProviderService } from './provider/IProviderService'

let instance: IProviderService | null = null

const tabUuid: string = crypto.randomUUID()

export function setInstance(service: IProviderService | null): void {
  instance = service
}

export function getInstance(): IProviderService | null {
  return instance
}

export function requireInstance(): IProviderService {
  if (!instance) throw new Error('Realtime service not initialized.')

  return instance
}

export function isRealtimeAvailable(): boolean {
  return instance !== null
}

export { tabUuid }
